/**
 * The element that actually scrolls for `el`. Pages scroll inside the app shell's content area,
 * not the window (LAY-01), so window.scrollY is always 0 there.
 */
export function scrollParent(el: Element | null | undefined): HTMLElement {
  let node = el?.parentElement ?? null;
  while (node) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
    node = node.parentElement;
  }
  return (document.scrollingElement as HTMLElement | null) ?? document.documentElement;
}
